import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const ITEMS_PER_PAGE = 10;

/**
 * Skeleton loading state for the Episode Listing page.
 * Matches the actual EpisodeListing layout structure.
 */
export const EpisodeListingSkeleton: React.FC = () => {
  return (
    <>
      {/* Section 1: Header Area - contained card */}
      <div className="max-w-content px-4 lg:px-8" style={{ paddingTop: '20px' }}>
      <div className="bg-podcast rounded-lg border border-border shadow-sm" style={{ padding: '20px 24px 24px 24px' }}>
        <div>
          {/* Page Title */}
          <Skeleton className="h-8 w-48 mb-5" />

          {/* Search and Filters Bar */}
          <div className="flex justify-between items-center">
            <div className="flex gap-2">
              <Skeleton className="h-9 w-64" />
              <Skeleton className="h-9 w-9" />
            </div>

            {/* Right side controls */}
            <div className="flex gap-4 items-center">
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-9 w-20" />
              <Skeleton className="h-9 w-9" />
              <Skeleton className="h-9 w-20" />
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* Section 3: Main Content - Table */}
      <div className="max-w-content pb-8 px-4 lg:px-8 pt-6">
        <div
          className="overflow-x-auto"
          style={{
            backgroundColor: 'var(--pm-bg-card)',
            border: '1px solid var(--pm-border-default)',
            borderRadius: '12px',
          }}
        >
          {/* Header skeleton */}
          <div
            className="flex items-center gap-4 px-4 py-3 min-w-0"
            style={{
              backgroundColor: 'var(--pm-cyan-bg)',
              borderBottom: '1px solid var(--pm-border-default)',
            }}
          >
            <div className="w-10 shrink-0" />
            <Skeleton className="h-3 w-16" />
            <div className="flex-1" />
            <Skeleton className="h-3 w-12 hidden lg:block" />
            <Skeleton className="h-3 w-12 hidden xl:block" />
            <Skeleton className="h-3 w-10 hidden lg:block" />
            <Skeleton className="h-3 w-12" />
          </div>

          {/* Row skeletons */}
          {Array.from({ length: ITEMS_PER_PAGE }).map((_, i) => (
            <div
              key={i}
              className="flex items-center gap-4 px-4 py-4 min-w-0"
              style={{
                borderBottom: i < ITEMS_PER_PAGE - 1 ? '1px solid var(--pm-border-default)' : 'none',
              }}
            >
              <Skeleton className="w-10 h-10 rounded-full shrink-0" />
              <div className="flex-1 min-w-0 space-y-2">
                <Skeleton className="h-4 w-2/3" />
                <Skeleton className="h-3 w-1/4" />
              </div>
              <Skeleton className="w-8 h-8 rounded-full shrink-0 hidden lg:block" />
              <Skeleton className="w-8 h-8 rounded-full shrink-0 hidden xl:block" />
              <Skeleton className="h-4 w-16 shrink-0 hidden lg:block" />
              <div className="w-32 flex justify-end shrink-0">
                <Skeleton className="h-6 w-24 rounded-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default EpisodeListingSkeleton;
